(function () {
  "use strict";

  window.PackageProtection = {
    setOptOut: function (optOut) {
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          attributes: { add_package_protection: optOut ? "false" : "true" },
        }),
      })
        .then(function () {
          window.dispatchEvent(new CustomEvent("cart:change"));
        })
        .catch(function () {});
    },
  };
})();
